import { useTemporaryMessageHeaderHeight } from '@shared/temporary-messages';

import { shouldUseEmbeddedLayout } from './layout/shouldUseEmbeddedLayout';

export const DEFAULT_NAVIGATION_HEIGHT = 80;

function getNavigationHeight(): number {
    if (shouldUseEmbeddedLayout()) {
        return 0;
    }
    return DEFAULT_NAVIGATION_HEIGHT;
}

export function useStripeHeaderStickyOffset(): number {
    const temporaryMessageHeaderHeight = useTemporaryMessageHeaderHeight();
    const navigationHeight = getNavigationHeight();

    return navigationHeight + temporaryMessageHeaderHeight;
}
